var exports = {
  "j": "Modals.module__modals___QkE3em",
};

module.exports = exports;
